// Web mock for react-native-image-picker
export const MediaType = {
  photo: 'photo',
  video: 'video',
  mixed: 'mixed',
};

export const ImageQuality = {
  0.1: 0.1,
  0.2: 0.2,
  0.3: 0.3,
  0.4: 0.4,
  0.5: 0.5,
  0.6: 0.6,
  0.7: 0.7,
  0.8: 0.8,
  0.9: 0.9,
  1.0: 1.0,
};

// Supported image MIME types (matching admin events pattern)
const SUPPORTED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

export function launchImageLibrary(options = {}, callback) {
  const input = document.createElement('input');
  input.type = 'file';
  // Use specific MIME types to limit to JPEG, PNG, GIF, WebP
  input.accept = SUPPORTED_IMAGE_MIME_TYPES.join(',');
  input.multiple = options.selectionLimit > 1;

  input.onchange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) {
      callback({ didCancel: true });
      return;
    }

    const assets = files.map(file => ({
      uri: URL.createObjectURL(file),
      fileName: file.name,
      fileSize: file.size,
      type: file.type,
      width: 0, // Would need to load image to get dimensions
      height: 0,
    }));

    callback({ assets });
  };

  input.oncancel = () => {
    callback({ didCancel: true });
  };

  input.click();
}

export function launchCamera(options = {}, callback) {
  // Camera not available on web, fallback to file picker
  launchImageLibrary(options, callback);
}

export default {
  MediaType,
  ImageQuality,
  launchImageLibrary,
  launchCamera,
};
